export const RESOURCE_COLORS = [
  {
    bg: "bg-blue-500",
    bgLight: "bg-blue-100",
    border: "border-blue-300",
    text: "text-blue-900"
  },
  {
    bg: "bg-green-500",
    bgLight: "bg-green-100",
    border: "border-green-300",
    text: "text-green-900"
  },
  {
    bg: "bg-purple-500",
    bgLight: "bg-purple-100",
    border: "border-purple-300",
    text: "text-purple-900"
  },
  {
    bg: "bg-orange-500",
    bgLight: "bg-orange-100",
    border: "border-orange-300",
    text: "text-orange-900"
  },
  {
    bg: "bg-pink-500",
    bgLight: "bg-pink-100",
    border: "border-pink-300",
    text: "text-pink-900"
  },
  {
    bg: "bg-red-500",
    bgLight: "bg-red-100",
    border: "border-red-300",
    text: "text-red-900"
  },
  {
    bg: "bg-indigo-500",
    bgLight: "bg-indigo-100",
    border: "border-indigo-300",
    text: "text-indigo-900"
  },
  {
    bg: "bg-teal-500",
    bgLight: "bg-teal-100",
    border: "border-teal-300",
    text: "text-teal-900"
  },
  {
    bg: "bg-yellow-500",
    bgLight: "bg-yellow-100",
    border: "border-yellow-300",
    text: "text-yellow-900"
  },
  {
    bg: "bg-cyan-500",
    bgLight: "bg-cyan-100",
    border: "border-cyan-300",
    text: "text-cyan-900"
  },
  {
    bg: "bg-emerald-500",
    bgLight: "bg-emerald-100",
    border: "border-emerald-300",
    text: "text-emerald-900"
  },
  {
    bg: "bg-rose-500",
    bgLight: "bg-rose-100",
    border: "border-rose-300",
    text: "text-rose-900"
  },
  {
    bg: "bg-violet-500",
    bgLight: "bg-violet-100",
    border: "border-violet-300",
    text: "text-violet-900"
  },
  {
    bg: "bg-amber-500",
    bgLight: "bg-amber-100",
    border: "border-amber-300",
    text: "text-amber-900"
  },
  {
    bg: "bg-lime-500",
    bgLight: "bg-lime-100",
    border: "border-lime-300",
    text: "text-lime-900"
  },
  {
    bg: "bg-sky-500",
    bgLight: "bg-sky-100",
    border: "border-sky-300",
    text: "text-sky-900"
  },
  {
    bg: "bg-fuchsia-500",
    bgLight: "bg-fuchsia-100",
    border: "border-fuchsia-300",
    text: "text-fuchsia-900"
  },
  {
    bg: "bg-slate-500",
    bgLight: "bg-slate-100",
    border: "border-slate-300",
    text: "text-slate-900"
  },
  {
    bg: "bg-gray-500",
    bgLight: "bg-gray-100",
    border: "border-gray-300",
    text: "text-gray-900"
  },
  {
    bg: "bg-zinc-500",
    bgLight: "bg-zinc-100",
    border: "border-zinc-300",
    text: "text-zinc-900"
  },
  {
    bg: "bg-red-600",
    bgLight: "bg-red-50",
    border: "border-red-400",
    text: "text-red-800"
  },
  {
    bg: "bg-blue-600",
    bgLight: "bg-blue-50",
    border: "border-blue-400",
    text: "text-blue-800"
  },
  {
    bg: "bg-green-600",
    bgLight: "bg-green-50",
    border: "border-green-400",
    text: "text-green-800"
  },
  {
    bg: "bg-purple-600",
    bgLight: "bg-purple-50",
    border: "border-purple-400",
    text: "text-purple-800"
  },
  {
    bg: "bg-yellow-600",
    bgLight: "bg-yellow-50",
    border: "border-yellow-400",
    text: "text-yellow-800"
  },
  {
    bg: "bg-cyan-600",
    bgLight: "bg-cyan-50",
    border: "border-cyan-400",
    text: "text-cyan-800"
  },
  {
    bg: "bg-indigo-600",
    bgLight: "bg-indigo-50",
    border: "border-indigo-400",
    text: "text-indigo-800"
  },
  {
    bg: "bg-stone-500",
    bgLight: "bg-stone-100",
    border: "border-stone-300",
    text: "text-stone-900"
  },
  {
    bg: "bg-neutral-500",
    bgLight: "bg-neutral-100",
    border: "border-neutral-300",
    text: "text-neutral-900"
  },
  {
    bg: "bg-red-700",
    bgLight: "bg-red-200",
    border: "border-red-400",
    text: "text-red-900"
  },
  {
    bg: "bg-orange-700",
    bgLight: "bg-orange-200",
    border: "border-orange-400",
    text: "text-orange-900"
  },
  {
    bg: "bg-amber-700",
    bgLight: "bg-amber-200",
    border: "border-amber-400",
    text: "text-amber-900"
  },
  {
    bg: "bg-lime-700",
    bgLight: "bg-lime-200",
    border: "border-lime-400",
    text: "text-lime-900"
  },
  {
    bg: "bg-green-700",
    bgLight: "bg-green-200",
    border: "border-green-400",
    text: "text-green-900"
  },
  {
    bg: "bg-emerald-700",
    bgLight: "bg-emerald-200",
    border: "border-emerald-400",
    text: "text-emerald-900"
  },
  {
    bg: "bg-teal-700",
    bgLight: "bg-teal-200",
    border: "border-teal-400",
    text: "text-teal-900"
  },
  {
    bg: "bg-sky-700",
    bgLight: "bg-sky-200",
    border: "border-sky-400",
    text: "text-sky-900"
  }
];

export const _mockAssignedResources = [
  {
    resource_id: 207,
    label: "Alex Johnson",
    start_date: "2024-07-04T04:00:00Z",
    end_date: "2024-07-05T04:00:00Z",
    is_assigned_to_me: true
  },
  {
    resource_id: 208,
    label: "Alex Kubik has a long name",
    start_date: "2024-07-08T04:00:00Z",
    end_date: "2024-07-10T04:00:00Z",
    is_assigned_to_me: false
  },
  {
    resource_id: 208,
    label: "Alex Kubik has a long name",
    start_date: "2025-07-08T04:00:00Z",
    end_date: "2025-07-10T04:00:00Z",
    is_assigned_to_me: false
  },
  {
    resource_id: 208,
    label: "Alex Kubik",
    start_date: "2025-07-11T04:00:00Z",
    end_date: "2025-07-12T04:00:00Z",
    is_assigned_to_me: false
  },
  {
    resource_id: 214,
    label: "Colm Donnell",
    start_date: "2025-06-23T04:00:00Z",
    end_date: "2025-06-28T04:00:00Z",
    is_assigned_to_me: false
  },
  {
    resource_id: 214,
    label: "Colm Donnell",
    start_date: "2025-06-30T04:00:00Z",
    end_date: "2025-07-04T04:00:00Z",
    is_assigned_to_me: false
  },
  {
    resource_id: 214,
    label: "Colm Donnell",
    start_date: "2025-07-07T04:00:00Z",
    end_date: "2025-07-10T04:00:00Z",
    is_assigned_to_me: false
  },
  {
    resource_id: 214,
    label: "Colm Donnell",
    start_date: "2025-07-11T04:00:00Z",
    end_date: "2025-07-12T04:00:00Z",
    is_assigned_to_me: false
  },
  {
    resource_id: 214,
    label: "Colm Donnell",
    start_date: "2025-07-14T04:00:00Z",
    end_date: "2025-07-18T04:00:00Z",
    is_assigned_to_me: false
  },
  {
    resource_id: 214,
    label: "Colm Donnell",
    start_date: "2025-07-21T04:00:00Z",
    end_date: "2025-07-26T04:00:00Z",
    is_assigned_to_me: false
  },
  {
    resource_id: 214,
    label: "Colm Donnell",
    start_date: "2025-07-28T04:00:00Z",
    end_date: "2025-08-02T04:00:00Z",
    is_assigned_to_me: false
  },
  {
    resource_id: 226,
    label: "Jason Mance",
    start_date: "2025-07-07T04:00:00Z",
    end_date: "2025-07-10T04:00:00Z",
    is_assigned_to_me: false
  },
  {
    resource_id: 226,
    label: "Jason Mance",
    start_date: "2025-07-11T04:00:00Z",
    end_date: "2025-07-12T04:00:00Z",
    is_assigned_to_me: false
  },
  {
    resource_id: 226,
    label: "Jason Mance",
    start_date: "2025-07-14T04:00:00Z",
    end_date: "2025-07-17T04:00:00Z",
    is_assigned_to_me: false
  },
  {
    resource_id: 241,
    label: "Michael Soma",
    start_date: "2025-07-07T04:00:00Z",
    end_date: "2025-07-10T04:00:00Z",
    is_assigned_to_me: false
  },
  {
    resource_id: 241,
    label: "Michael Soma",
    start_date: "2025-07-11T04:00:00Z",
    end_date: "2025-07-12T04:00:00Z",
    is_assigned_to_me: false
  },
  {
    resource_id: 241,
    label: "Michael Soma",
    start_date: "2025-07-14T04:00:00Z",
    end_date: "2025-07-17T04:00:00Z",
    is_assigned_to_me: false
  },
  {
    resource_id: 257,
    label: "Timothy Gall",
    start_date: "2025-07-11T04:00:00Z",
    end_date: "2025-07-12T04:00:00Z",
    is_assigned_to_me: false
  },
  {
    resource_id: 358,
    label: "S105",
    start_date: "2025-07-09T04:00:00Z",
    end_date: "2025-07-11T04:00:00Z",
    is_assigned_to_me: true
  },
  {
    resource_id: 358,
    label: "S105",
    start_date: "2025-07-15T04:00:00Z",
    end_date: "2025-07-19T04:00:00Z",
    is_assigned_to_me: true
  },
  {
    resource_id: 815,
    label: "Nislo Depina",
    start_date: "2025-07-07T04:00:00Z",
    end_date: "2025-07-12T04:00:00Z",
    is_assigned_to_me: false
  },
  {
    resource_id: 815,
    label: "Nislo Depina",
    start_date: "2025-07-15T04:00:00Z",
    end_date: "2025-07-19T04:00:00Z",
    is_assigned_to_me: false
  },
  {
    resource_id: 23805,
    label: "Ramon Flake",
    start_date: "2025-06-30T04:00:00Z",
    end_date: "2025-07-04T04:00:00Z",
    is_assigned_to_me: false
  },
  {
    resource_id: 23805,
    label: "Ramon Flake",
    start_date: "2025-07-07T04:00:00Z",
    end_date: "2025-07-11T04:00:00Z",
    is_assigned_to_me: false
  },
  {
    resource_id: 23805,
    label: "Ramon Flake",
    start_date: "2025-07-14T04:00:00Z",
    end_date: "2025-07-19T04:00:00Z",
    is_assigned_to_me: false
  },
  {
    resource_id: 27123,
    label: "Jim Murphy",
    start_date: "2025-07-11T04:00:00Z",
    end_date: "2025-07-12T04:00:00Z",
    is_assigned_to_me: false
  },
  {
    resource_id: 30906,
    label: "S120BK",
    start_date: "2025-06-30T04:00:00Z",
    end_date: "2025-07-04T04:00:00Z",
    is_assigned_to_me: true
  },
  {
    resource_id: 30906,
    label: "S120BK",
    start_date: "2025-07-07T04:00:00Z",
    end_date: "2025-07-12T04:00:00Z",
    is_assigned_to_me: true
  },
  {
    resource_id: 30906,
    label: "S120BK",
    start_date: "2025-07-14T04:00:00Z",
    end_date: "2025-07-19T04:00:00Z",
    is_assigned_to_me: true
  },
  {
    resource_id: 31845,
    label: "S92R",
    start_date: "2025-06-30T04:00:00Z",
    end_date: "2025-07-03T04:00:00Z",
    is_assigned_to_me: false
  },
  {
    resource_id: 31845,
    label: "S92R",
    start_date: "2025-07-07T04:00:00Z",
    end_date: "2025-07-09T04:00:00Z",
    is_assigned_to_me: false
  },
  {
    resource_id: 40304,
    label: "Rack Truck",
    start_date: "2025-07-01T04:00:00Z",
    end_date: "2025-07-02T04:00:00Z",
    is_assigned_to_me: false
  },
  {
    resource_id: 51146,
    label: "David Frey",
    start_date: "2025-06-23T04:00:00Z",
    end_date: "2025-06-28T04:00:00Z",
    is_assigned_to_me: false
  },
  {
    resource_id: 51146,
    label: "David Frey",
    start_date: "2025-06-30T04:00:00Z",
    end_date: "2025-07-04T04:00:00Z",
    is_assigned_to_me: false
  },
  {
    resource_id: 51146,
    label: "David Frey",
    start_date: "2025-07-07T04:00:00Z",
    end_date: "2025-07-08T04:00:00Z",
    is_assigned_to_me: false
  },
  {
    resource_id: 51146,
    label: "David Frey",
    start_date: "2025-07-09T04:00:00Z",
    end_date: "2025-07-10T04:00:00Z",
    is_assigned_to_me: false
  },
  {
    resource_id: 51146,
    label: "David Frey",
    start_date: "2025-07-11T04:00:00Z",
    end_date: "2025-07-12T04:00:00Z",
    is_assigned_to_me: false
  },
  {
    resource_id: 51146,
    label: "David Frey",
    start_date: "2025-07-14T04:00:00Z",
    end_date: "2025-07-19T04:00:00Z",
    is_assigned_to_me: false
  },
  {
    resource_id: 51146,
    label: "David Frey",
    start_date: "2025-07-21T04:00:00Z",
    end_date: "2025-07-26T04:00:00Z",
    is_assigned_to_me: false
  },
  {
    resource_id: 51146,
    label: "David Frey",
    start_date: "2025-07-28T04:00:00Z",
    end_date: "2025-08-02T04:00:00Z",
    is_assigned_to_me: false
  }
];
